export default {
  data() {
    return {
      companyACN: "672 937 950",
      compantTitle1: "Besea",
      companyTitle2: "besea",
      companyTitle3: "Besea Pty Ltd",
      companyEmail1: "contact@besea.com.au",
      // eslint-disable-next-line
      companyDescription1: "besea asset management software maintains safe and reliable facility operations and enables transition to low carbon and sustainable future.",
      // eslint-disable-next-line
      companyDescription2: "besea software is owned, operated and maintained by Besea Pty Ltd. The system uses state of the art third party cloud service provided to ensure security, data privacy and outstanding user experience.",
      // eslint-disable-next-line
      companyDescription3: "besea is a cloud based asset management software for facility managers and asset operators to maintain safe and reliable operation and plan to transition to low carbon and sustainable future.",
      // eslint-disable-next-line
      companyDescription4: "company corporate, facility operations and asset management in one system",
      // eslint-disable-next-line
      companyDescription5: "besea’s cloud based asset management software helps facility managers and asset operators to maintain safe and reliable operation and plan to transition to low carbon and sustainable future.",
      // eslint-disable-next-line
      companyCondition1: "besea platform is Software as a Service (SaaS) and you should be familiar with Data Privacy Policy and Terms of Use Policy to understand your rights and our obligations. Besea has implemented risk controls to ensure that data transfer between you and your authentication vendors or contractors is secure."
    };
  }
};
